;

import { useEffect, useState } from 'react'
import Button from '@/components/ui/Button'
import { useNavigate } from 'react-router-dom'
import { useModal } from '@/contexts/ModalContext'
import ShowEditorModal from '@/components/modals/ShowEditorModal'
import Loader from '@/components/loader'
import { useShow } from '@/contexts/ShowContext'
import { useUser } from '@/contexts/UserContext'
import useFileUpload from '@/hooks/useFileUpload'

export default function Home() {
    const navigate = useNavigate()
    const {openModal} = useModal()
    const [loading, setLoading] = useState(false)
    const {user, authLoaded} = useUser()
    const {show, createShow} = useShow()
    const {uploadFile} = useFileUpload()

    useEffect(() => {
        if(authLoaded && !user){
            navigate('/login')
        }
    }, [authLoaded, user])

    const handleAddShow = async () => {
        const data = await openModal(<ShowEditorModal />, 'side')
        if(data){
            setLoading(true)
            try{

                if(data.thumbnailFile){
                    const uploadResponse = await uploadFile(data.thumbnailFile)
                    data.thumbnail_url = uploadResponse.url
                    data.thumbnail_key = uploadResponse.key
                    delete data.thumbnailFile
                }

                await createShow(data)
                navigate(`/show/episodes`)
            }catch(error){
                console.error(error)
                setLoading(false)
            }
        }
    }

    useEffect(() => {
        if(show){
            setLoading(true)
            navigate(`/show/episodes`)
        }
    }, [show])

    return (
        <div className="min-h-screen p-8 flex flex-col items-center justify-center">
            <h1 className="text-8xl font-bold mb-6 text-primary italic">kagami</h1>
            <p className="text-lg text-secondary-foreground">Welcome friend 👋</p>
            <p className="text-md text-secondary-foreground">Start by adding a new show!</p>
            <div className="flex gap-2 mt-6">
                <Button type='secondary' onClick={handleAddShow}>New Show</Button>
            </div>
            {loading && <Loader />}
        </div>
    );
}
